import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { DlgCitaprogramComponent } from './dlg-citaprogram/dlg-citaprogram.component';
import { DlgEditarCuentaComponent } from './dlg-editar-cuenta/dlg-editar-cuenta.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
// import { ReasignacionModalComponent } from './reasignacion-modal/reasignacion-modal.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DescargarLotesComponent } from 'src/app/home/descargar-lotes/descargar-lotes.component';
import { BitacoraDialogComponent } from 'src/app/components/bitacora-dialog/bitacora-dialog.component';
import { TipoServicioService } from '../tipo-servicio.service';

@Component({
  selector: 'app-citas-programadas',
  templateUrl: './citas-programadas.component.html',
  styleUrls: ['./citas-programadas.component.scss']
})
export class CitasProgramadasComponent implements OnInit {
  private destroy$ = new Subject<void>();
  minDate = new Date();
  maxDate = new Date();
  agentes = [{
    idagente: 0,
    nombre: 'Todos'
  }];
  agentesFiltrados: any[] = [];
  searchTecnico = '';
  /** Catalogo de estados del filtro; se carga desde la BD (ref_cita_status). */
  estados: any[] = [];

  tiempos = [
    {
      id: 0,
      name: 'Todos'
    },
    {
      id: 'AM',
      name: 'AM'
    },
    {
      id: 'PM',
      name: 'PM'
    }
  ];

  provincias: any[] = [];

  grupoVal = new FormGroup({
    BUSCAR: new FormControl(''),
    PRIORIDAD: new FormControl(0),
    CONTRATA_TECNICO: new FormControl([]),
    AGENTE: new FormControl([]),
    ESTADO: new FormControl(''),
    TIEMPO: new FormControl(0),
    PROVINCIA: new FormControl(''),
    FECHAINI: new FormControl(new Date()),
    FECHAFIN: new FormControl(new Date()),
  });
  usuariosCant = 5;
  tableColumns: string[] = ['ID', 'FALLA', 'ESTADO', 'CONTRATA', 'AGENTE', 'CUENTA', 'DIRECCION', 'LOCALIZACION', 'ALERTA_ZONA', 'FECHAVISITA', 'AMPM', 'PRIORIDAD', 'TIPOLOGIA', 'SUBTIPOLOGIA', 'BOX', 'ACCION'];
  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent
  public actpage: number = 0;
  prioridades = [];
  contratasagente = [];
  detalleRiesgoCache: { [idZona: number]: any[] } = {};
  @ViewChild('paginatortable') paginatortable: MatPaginator;
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar,
    private _tipoServicio: TipoServicioService
  ) { }

  puedeEditar = true;

  private _tienePermiso(modulo: string, tipo: string = 'ver'): boolean {
    const user = this.localSave.get('usuarioPGV');
    if (!user || !user.permisos) return false;
    const perm = user.permisos.find(p => p.modulo === modulo);
    if (!perm) return false;
    return perm['permiso_' + tipo] === 1;
  }

  async ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    await this.getTecnicosxContrata();
    this.getPrioridades();
    this.getProvincias();
    this.getEstados();
    this.getContratasAgente();
    const tieneAcceso = this._tienePermiso('CITAS_PROGRAMADAS');
    if (!user || (!tieneAcceso && user.idrol != 1 && user.idrol != 23 && user.idrol != 24 && user.idrol != 27)) {
      // Para agentes (idrol=17) usar /homeagente como fallback en lugar de /home
      const fallback = Number(user && user.idrol) === 17 ? '/homeagente' : '/home';
      this.router.navigate([fallback]);
    }
    // puedeEditar se deriva del permiso explicito de editar:
    //  - Roles dinamicos (>=28) y agentes (17 con rol alterno) lo respetan
    //  - Admin (1) y contratas (23/24/27) mantienen edicion completa
    if (user && (user.idrol >= 28 || Number(user.idrol) === 17)) {
      this.puedeEditar = this._tienePermiso('CITAS_PROGRAMADAS', 'editar');
    }
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Citas';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarAgente(res.filtro);
      });
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        // this.createAgente();
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
    this._tipoServicio.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      // Limpiar filtros de contrata y técnico al cambiar Instalaciones/Reparaciones
      this.grupoVal.get('CONTRATA_TECNICO').setValue([]);
      this.grupoVal.get('AGENTE').setValue([]);
      this.searchTecnico = '';
      this.getTecnicosxContrata().then(() => {
        this.getContratasAgente();
        this.get(0);
      });
    });
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    if (this.paginatortable) {
      this.paginatortable.firstPage();
    }
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  onContrataSeleccionada(event: any) {
    this.gateway.get('gettecnicosxcontrata', {
      IDPAIS: 5,
      IDDISTRIBUIDOR: (this._tipoServicio.getValorActual().IDU || null),
      IDPADRE: (this._tipoServicio.getValorActual().IDU || null),
      IDAREA: (this._tipoServicio.getValorActual().IDAREA || null),
      provincias: null,
      IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(event.value),
    }).then((result) => {
      let aux: any = result;
      if (aux.rows.length > 0) {
        this.agentes = aux.rows;
        this.filtrarTecnicos();
      } else {
      }
    }).catch((e) => {
    });
  }

  getContratasAgente() {
    this.gateway.get('getContrata', { NUM_PAGINA: 0, FILTRO: this.FILTER, NUM_ELEMENTOS: 5, IDPAIS: this.idpais, IDAREA: (this._tipoServicio.getValorActual().IDAREA || null) }).then((result) => {
      // console.log(result);
      let aux: any = result;
      this.contratasagente = aux.rows;
    }
    ).catch((e) => {
    });
  }

  limpiarFiltros() {
    this.grupoVal.reset();
    this.grupoVal.controls.AGENTE.setValue([]);
    this.grupoVal.controls.CONTRATA_TECNICO.setValue([]);
    this.grupoVal.controls.TIEMPO.setValue(0);
    this.grupoVal.controls.PROVINCIA.setValue('');
    this.grupoVal.controls.FECHAINI.setValue(new Date());
    this.grupoVal.controls.FECHAFIN.setValue(new Date());
    this.get(0);
  }

  /** Devuelve el valor de CONTRATA_TECNICO o null si está vacío */
  private getContrataValue(val?: any): any {
    const v = val !== undefined ? val : this.grupoVal.get('CONTRATA_TECNICO').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  /** Devuelve el valor de AGENTE o null si está vacío */
  private getAgenteValue(): any {
    const v = this.grupoVal.get('AGENTE').value;
    return (Array.isArray(v) && v.length > 0) ? v : (v && !Array.isArray(v)) ? v : null;
  }

  /** Filtra la lista de técnicos según texto de búsqueda */
  filtrarTecnicos() {
    const term = (this.searchTecnico || '').trim().toLowerCase();
    if (!term) {
      this.agentesFiltrados = this.agentes;
    } else {
      this.agentesFiltrados = this.agentes.filter(a =>
        a.nombre.toLowerCase().includes(term)
      );
    }
  }

  /** Limpia búsqueda al abrir/cerrar dropdown de técnicos */
  onTecnicoDropdownToggle(opened: boolean) {
    if (opened) {
      this.searchTecnico = '';
      this.filtrarTecnicos();
    }
  }

  public descargar() {
    const dialogRef = this.dialog.open(DescargarLotesComponent, {
      disableClose: true,
      width: '700px',
      // height: '300px',
      data: {
        cantPorPagina: 1000,
        nombreServicioCantRegistros: 'getcountcitasprogramadas', // deve devolver total:number
        nombreServicioRegistros: 'getcitasprogramadasdescarga', // deve devolver rows:[]
        params: {
          // NUM_PAGINA: page,
          // NUM_ELEMENTOS: this.pageSize,
          IDAGENTE: this.getAgenteValue(),
          PRIORIDAD: this.grupoVal.controls.PRIORIDAD.value,
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          IDESTADO: this.grupoVal.controls.ESTADO.value || [],
          FECHAINI: this.grupoVal.controls.FECHAINI.value,
          FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
          FILTRO: this.FILTER,
          IDPAIS: this.idpais,
          IDDISTRIBUIDOR: (this._tipoServicio.getValorActual().IDU || null),
          IDPADRE: (this._tipoServicio.getValorActual().IDU || null),
          IDAREA: (this._tipoServicio.getValorActual().IDAREA || null),
          IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
          IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
        }
      }
    });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp.valid) {
        const filtros = resp.result;
      }
    });
  }

  getTecnicosxContrata() {
    return new Promise((resolve, reject) => {
      this.gateway.get('gettecnicosxcontrata', {
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: (this._tipoServicio.getValorActual().IDU || null),
        IDPADRE: (this._tipoServicio.getValorActual().IDU || null),
        IDAREA: (this._tipoServicio.getValorActual().IDAREA || null),
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2,
        IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
      }).then((result) => {
        let aux: any = result;
        if (aux.rows.length > 0) {
          this.agentes = aux.rows;
          this.filtrarTecnicos();
          resolve(true);
        } else {
          resolve(false);
        }
      }).catch((e) => {
        reject(e);
      });
    })
  }

  getPrioridades() {
    this.gateway.get('getprioridades', {}).then((result) => {
      let aux: any = result;
      this.prioridades = aux;
    }
    ).catch(function (e) {
    });
  }

  getProvincias() {
    this.gateway.get('getprovincias', {}).then((result: any) => {
      this.provincias = result.rows || [];
    }).catch(function (e) {});
  }

  getEstados() {
    this.gateway.get('getestadoscita', {}).then((result: any) => {
      this.estados = result.rows || [];
    }).catch(function (e) {});
  }

  get(page) {
    this.spinner.show();
    this.gateway.get('getcitasprogramadas',
      {
        IDAGENTE: this.getAgenteValue(),
        PRIORIDAD: this.grupoVal.controls.PRIORIDAD.value,
        TIEMPO: this.grupoVal.controls.TIEMPO.value,
        IDESTADO: this.grupoVal.controls.ESTADO.value || [],
        FECHAINI: this.grupoVal.controls.FECHAINI.value,
        FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
        NUM_PAGINA: page,
        FILTRO: this.FILTER,
        NUM_ELEMENTOS: this.pageSize,
        IDPAIS: this.idpais,
        IDDISTRIBUIDOR: (this._tipoServicio.getValorActual().IDU || null),
        IDPADRE: (this._tipoServicio.getValorActual().IDU || null),
        IDAREA: (this._tipoServicio.getValorActual().IDAREA || null),
        IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
        IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
        IDPROVINCIA: this.grupoVal.controls.PROVINCIA.value || null,
      }).then((result) => {

        let aux: any = result;
        this.dataSource = aux.rows;
        //this.resultsLength = 3//;result[1][0].TOTAL;

        this.gateway.get('getcountcitasprogramadas', {
          IDAGENTE: this.getAgenteValue(),
          PRIORIDAD: this.grupoVal.controls.PRIORIDAD.value,
          TIEMPO: this.grupoVal.controls.TIEMPO.value,
          IDESTADO: this.grupoVal.controls.ESTADO.value || [],
          FECHAINI: this.grupoVal.controls.FECHAINI.value,
          FECHAFIN: this.grupoVal.controls.FECHAFIN.value,
          NUM_PAGINA: page,
          FILTRO: this.FILTER,
          NUM_ELEMENTOS: this.pageSize,
          IDPAIS: this.idpais,
          IDDISTRIBUIDOR: (this._tipoServicio.getValorActual().IDU || null),
          IDPADRE: (this._tipoServicio.getValorActual().IDU || null),
          IDAREA: (this._tipoServicio.getValorActual().IDAREA || null),
          IDCONTRATA2: this.localSave.get('usuarioPGV').IDCONTRATA2 || this.getContrataValue(),
          IDAREAAGENTE: this.localSave.get('usuarioPGV').idrol === 24 ? null : this.localSave.get('usuarioPGV').IDAREAAGENTE,
          IDPROVINCIA: this.grupoVal.controls.PROVINCIA.value || null,
        }).then((result: any) => {
          this.resultsLength = result.rows[0].total;
          this.spinner.hide();
        });

      }
      ).catch(function (e) {
      });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  // ============== Helpers UI ==============

  /**
   * Devuelve true si la cita tiene hora puntual registrada (RF-08).
   */
  tieneHoraPuntual(element: any): boolean {
    return !!(element && element.hora_puntual);
  }

  /**
   * Formatea la hora puntual en formato HH:MM (recorta segundos si vienen).
   */
  formatearHoraPuntual(element: any): string {
    if (!this.tieneHoraPuntual(element)) return '';
    return String(element.hora_puntual).substring(0, 5);
  }

  /**
   * Color de chip segun estado de la cita.
   * Ids segun el catalogo ref_cita_status de la BD (1-8 con color propio, resto gris).
   */
  getEstadoColor(idestado: number): string {
    switch (Number(idestado)) {
      case 1: return '#90a4ae'; // gris — Pendiente de asignar
      case 2: return '#1976d2'; // azul — Asignada
      case 3: return '#26a69a'; // verde agua — Tecnico en camino
      case 4: return '#43a047'; // verde — Tecnico en sitio
      case 5: return '#2e7d32'; // verde oscuro — Finalizado
      case 6: return '#fb8c00'; // naranja — Devuelta
      case 7: return '#e53935'; // rojo — Cancelar
      case 8: return '#c62828'; // rojo oscuro — Cancelar por reagendamiento
      default: return '#78909c';
    }
  }

  /**
   * Color de chip segun nivel de prioridad (texto nivel).
   */
  getPrioridadColor(nivel: string): string {
    const n = (nivel || '').toLowerCase();
    if (n.includes('urgente')) return '#e53935';
    if (n.includes('alto') || n.includes('alta')) return '#fb8c00';
    if (n.includes('medio') || n.includes('media')) return '#fdd835';
    return '#90a4ae'; // Normal o desconocido
  }

  /**
   * Formatea la fecha de visita en formato humano: "Hoy", "Manana", "Ayer" o "dd MMM".
   * Input esperado: string YYYY-MM-DD.
   */
  formatFechaHumana(fechaStr: string): string {
    if (!fechaStr) return '';
    const partes = String(fechaStr).split('-');
    if (partes.length !== 3) return fechaStr;
    const [yyyy, mm, dd] = partes.map(Number);
    const fecha = new Date(yyyy, mm - 1, dd);
    if (isNaN(fecha.getTime())) return fechaStr;

    const hoy = new Date();
    const soloFecha = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const diffDias = Math.round((soloFecha(fecha) - soloFecha(hoy)) / (1000 * 60 * 60 * 24));

    if (diffDias === 0) return 'Hoy';
    if (diffDias === 1) return 'Manana';
    if (diffDias === -1) return 'Ayer';

    const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
    return `${String(dd).padStart(2, '0')} ${meses[mm - 1]}`;
  }

  /**
   * Carga el detalle de riesgo (lluvia/cierre de calles) de una zona y lo cachea
   * por idZona para evitar pedidos repetidos.
   */
  cargarDetalleRiesgo(idZona: number): void {
    if (idZona == null || this.detalleRiesgoCache[idZona]) { return; }
    this.gateway.get('riesgozonadetalle', { ID_ZONA: idZona }).then((result) => {
      let aux: any = result;
      this.detalleRiesgoCache[idZona] = aux.rows || [];
    }).catch((e) => {
      this.detalleRiesgoCache[idZona] = [];
    });
  }

  /**
   * Indica si la cita tiene alerta de zona (lluvia o cierre de calles) reportada hoy.
   */
  tieneAlertaZona(cita: any): boolean {
    return (cita && cita.riesgo_lluvia > 0) || (cita && cita.riesgo_cierre > 0);
  }

  /**
   * Arma el texto del tooltip de alerta de zona con el detalle cacheado
   * (tecnico + hora) o, si aun no se cargo, un texto generico.
   */
  tooltipRiesgo(idZona: number, tipo: 'lluvia' | 'cierre'): string {
    const detalle = this.detalleRiesgoCache[idZona] || [];
    const delTipo = detalle.filter((d: any) => d.tipo === tipo);
    if (!delTipo.length) {
      return tipo === 'lluvia' ? 'Reporte(s) de lluvia en esta zona hoy' : 'Reporte(s) de cierre de calles en esta zona hoy';
    }
    const titulo = tipo === 'lluvia' ? 'Lluvia reportada por:' : 'Calle cerrada reportada por:';
    const lineas = delTipo.map((d: any) => `• ${d.tecnico_nombre} — ${this.formatearHora(d.hora)}`);
    return [titulo, ...lineas].join('\n');
  }

  /**
   * Extrae HH:mm de una hora en formato 'YYYY-MM-DD HH:mm:ss'.
   */
  private formatearHora(hora: string): string {
    if (!hora) { return ''; }
    const m = String(hora).match(/\d{2}:\d{2}/);
    return m ? m[0] : String(hora);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
    this.subscriptioncreate.unsubscribe();
    this.subscriptionpais.unsubscribe();
  }

  // createAgente() {
  //   const dialogRef = this.dialog.open(CreateAgenteComponent, {
  //     maxWidth: '130vw',
  //     width: '900px',
  //     minHeight: '50vh',
  //     data: { operacion: 'Crear', agente: { idpais: this.idpais } },
  //     disableClose: true
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //     this.get(this.actpage);
  //   });
  // }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0)
  }

  edit(element: any) {
    // console.log('cita:', element)
    //element.idpais = this.idpais;
    const dialogRef = this.dialog.open(DlgCitaprogramComponent, {
      maxWidth: '90%',
      width:'auto',
      // minHeight: '20vh',
      data: { operacion: 'Editar', agente: element, IDAREA: this._tipoServicio.getValorActual().IDAREA },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

  verBitacora(element: any): void {
    this.dialog.open(BitacoraDialogComponent, {
      width: '80%',
      panelClass: 'bitacora-dialog-panel',
      data: { cita: element }
    });
  }

  liberarCita(element: any): void {
    const codigo = element.numero_orden || element.falla || element.id;
    const tipoActual = this._tipoServicio.getValorActual();
    const tipo = tipoActual.IDAREA === 14 ? 'orden' : 'falla';
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '450px',
      data: {
        msj: `liberar la ${tipo} ${codigo}`,
        id: { IDCITA: element.id }
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.resp) {
        const usuario = this.localSave.get('usuarioPGV');
        this.gateway.save('liberarcita', {
          IDCITA: element.id,
          COMENTARIO: result.comentario,
          IDUSUARIO: usuario.IDU,
          NOMBRE_USUARIO: this.localSave.get('userLoggedIn') || null,
          CORREO_USUARIO: this.localSave.get('email') || null
        }).then((res: any) => {
          if (res && res.response === 1) {
            this.get(this.actpage);
          }
        });
      }
    });
  }

  editarCuenta(element: any): void {
    const dialogRef = this.dialog.open(DlgEditarCuentaComponent, {
      width: '400px',
      data: { cita: element },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

}
